interface Bindings {
	banners: any[];
}

export class GoBannerListController implements Bindings {
	public banners: any[];

	/* @ngInject */
	constructor (private goBannerHelper, private goBannerService) {
	}

	public $onInit () {
	}

	public removeBanner (banner) {
		this.goBannerHelper.setViewedStatus(banner);
		this.goBannerService.removeBanner(banner);
	}
}
